import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { IconButton } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  CallConferencePopUpContent,
  CallDialpadPopUpButton,
  CallDialpadPopUpContent,
  CallDisconnectPopUpButton,
  CallHoldPopUpButton,
  CallMessagePopUpContent,
  CallMicPopUpContent,
  CallMicPopUpIncomingButton,
  CallMicPopUpOutgoingButton,
  CallRecordPopUpButton,
  CallTransferPopUpContent,
  CallVoicemailDropButton,
  CallVoicemailDropContent,
} from 'widgets/CallPopUp'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { CallConferencePopUpButton } from 'widgets/CallPopUp/ui/CallConferencePopUp/CallConferencePopUpButton'
import { CallMessagePopUpButton } from 'widgets/CallPopUp/ui/CallMessagePopUp/CallMessagePopUpButton'
import { CallTransferPopUpButton } from 'widgets/CallPopUp/ui/CallTransferPopUp/CallTransferPopUpButton'
import { BaseContent } from 'widgets/CallPopUp/ui/components/BaseContent/BaseContent'
import styles from '../../styles.module.scss'

export const CallBaseContent = observer(() => {
  const { callStore } = useEntitiesContext()
  const store = useCallPopUpDefaultContext()
  const {
    isConference,
    isTransfer,
    isMessage,
    isDialpad,
    isHold,
    isMic,
    label,
    isShowVoicemailDropContent,
    isShowVoicemailDropButton,
    avatarsInfo,
    contactsNames,
    contactsPhones,
    isOneParticipant,
  } = store

  return (
    <>
      <BaseContent
        withPadding={isShowVoicemailDropContent}
        avatarsInfo={avatarsInfo}
        isHold={isHold}
        name={contactsNames}
        number={isOneParticipant ? contactsPhones : undefined}
        desc={label}
        actionsTop={
          <>
            {callStore.isAcceptVoice && (
              <>
                {isShowVoicemailDropButton && <CallVoicemailDropButton />}
                <CallDisconnectPopUpButton />
              </>
            )}
          </>
        }
        actionsBottom={
          <>
            {callStore.isAcceptVoice && (
              <div className={styles.foot}>
                <div className={styles.foot__item}>
                  <CallMicPopUpOutgoingButton />
                </div>
                <div className={styles.foot__item}>
                  <CallRecordPopUpButton />
                </div>
                <div className={styles.foot__item}>
                  <CallDialpadPopUpButton />
                </div>
                <div className={styles.foot__item}>
                  <CallHoldPopUpButton />
                </div>
                <div className={styles.foot__item}>
                  <CallTransferPopUpButton />
                </div>
                <div className={styles.foot__item}>
                  <CallConferencePopUpButton />
                </div>
              </div>
            )}

            {!callStore.isAcceptVoice && (
              <div className={classnames(styles.foot, styles['foot--incoming'])}>
                <div className={styles.foot__item}>
                  <IconButton
                    size={'large'}
                    color={'green'}
                    icon={'phone'}
                    fullWidth
                    tooltipProps={{
                      zIndex: ZIndex.OVERLAY_TOP_1,
                      label: 'Accept',
                      placement: 'top',
                    }}
                    onClick={() => {
                      callStore.acceptTwilio()
                    }}
                    ariaLabel='CallBaseContent_accept'
                  />
                </div>
                <div className={styles.foot__item}>
                  <CallDisconnectPopUpButton fullWidth={true} />
                </div>
                <div className={styles.foot__item}>
                  <CallMicPopUpIncomingButton />
                </div>
                <div className={styles.foot__item}>
                  <CallMessagePopUpButton />
                </div>
              </div>
            )}
          </>
        }
        content={
          <>
            {isMic && <CallMicPopUpContent />}
            {isDialpad && <CallDialpadPopUpContent />}
            {isMessage && <CallMessagePopUpContent />}
            {isTransfer && <CallTransferPopUpContent />}
            {isConference && <CallConferencePopUpContent />}
            {isShowVoicemailDropContent && <CallVoicemailDropContent />}
          </>
        }
      />
    </>
  )
})
